import React from 'react';
import {IProduct} from 'data/interfaces/products';
import styles from './PlaceDetailsCard.module.scss';

import InfoCard from '../infoCard';

import {formatTitle} from 'data/utils/shortcuts';
import {SizeMe} from 'react-sizeme';
import PlaceImagesSquare from './components/placeImagesSquare';
import {getPlaceDetailsName, isVoucherWithPlace} from 'data/redux/selectors/productSelector';
import {generateAssetList} from "./utils";

interface IPlaceDetailsCardProps {
  title?: string;
  mobileTitle?: string;
  toolTip?: string;
  mobileTooltip?: string;
  product?: IProduct;
  icon?: any;
  infoComponent?: any;
  children?: any;
}

const PlaceDetailsCard = (props: IPlaceDetailsCardProps) => {
  if (isVoucherWithPlace(props.product)) {
    const name = getPlaceDetailsName(props.product);
    if (name && generateAssetList(props.product).length > 0) {
      return (
        <SizeMe>{({size: {width}}) => {
          const isMobile = width <= 546;
          if (isMobile) {
            return <div>
              <PlaceImagesSquare product={props.product}/>
              <InfoCard
                title={props.mobileTitle || props.title || formatTitle(name)}
                icon={props.icon}
                toolTip={props.toolTip || props.mobileTooltip}
                style={{marginTop: 14}}
                defaultExpanded={true}
              >
                {props.infoComponent ? <props.infoComponent product={props.product} hideTitle/> : null}
                {props.children}
              </InfoCard>
            </div>
          } else
            return (
              <InfoCard
                title={props.title || formatTitle(name)}
                icon={props.icon}
                toolTip={props.toolTip}
                defaultExpanded={true}
              >
                <PlaceImagesSquare product={props.product} className={styles.PlaceDetailsCard}>
                  {props.infoComponent ?
                    <props.infoComponent product={props.product} className={styles.PlaceDetailsCard}/> : null}
                  {props.children}
                </PlaceImagesSquare>
              </InfoCard>);
        }
        }</SizeMe>
      );
    }
  }
  return null;
};


PlaceDetailsCard.defaultProps = {
  title: '',
  mobileTitle: '',
  toolTip: '',
  mobileTooltip: ''

};

export default React.memo(PlaceDetailsCard);
